"use strict";

exports.__esModule = true;
exports.default = createTheme;
exports.nonTokenVariables = void 0;

var _mineralUiTokens = _interopRequireDefault(require("mineral-ui-tokens"));

var _createColorRamp = _interopRequireDefault(require("./createColorRamp"));

var _fontSizeBase = _interopRequireDefault(require("./fontSizeBase"));

var _colorAliases = _interopRequireDefault(require("./generated/colorAliases"));

var _groupedByRampJsTokens = _interopRequireDefault(require("./generated/groupedByRampJsTokens"));

var _palette = _interopRequireDefault(require("./generated/palette"));

var _themeFromTokens = _interopRequireWildcard(require("./themeFromTokens"));

var _constants = require("./constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var primaryColors = Object.keys(_constants.PRIMARY_COLOR);

var nonTokenVariables = function nonTokenVariables(colors) {
  return {
    boxShadow_focusInner: colors && colors.white || _palette.default.white,
    direction: 'ltr',
    fontSize_base: _fontSizeBase.default
  };
};

exports.nonTokenVariables = nonTokenVariables;

var colorOverrides = function colorOverrides(colors) {
  return Object.keys(_groupedByRampJsTokens.default).reduce(function (acc, color) {
    return colors[color] ? _objectSpread({}, acc, (0, _themeFromTokens.themeFromColorTokens)({
      color: correctColorType(colors[color], color),
      colorName: color,
      tokens: _groupedByRampJsTokens.default[color]
    })) : acc;
  }, {});
};

var correctColorType = function correctColorType(colorValue, color) {
  var isStringColor = ['black', 'white'].indexOf(color) !== -1;
  return typeof colorValue === 'string' && isStringColor ? colorValue : getRamp(colorValue, color);
};

var getRamp = function getRamp(color, keyName) {
  if (typeof color === 'string') {
    if (_palette.default[color]) {
      return _palette.default[color];
    } else {
      throw new Error("[mineral-ui/themes/createTheme]: Expected colors." + keyName + " to be a color ramp from the mineral-ui palette or a custom color ramp, but got '" + color + "'.\nSee https://mineral-ui.com/color#guidelines-ramps for the palette ramps.\nSee https://github.com/mineral-ui/mineral-ui/blob/master/packages/mineral-ui-tokens/src/blue.js for an example color ramp.");
    }
  }

  var ignoreInflection = color.inflection,
      ramp = _objectWithoutPropertiesLoose(color, ["inflection"]);

  return ramp;
};

var getWhiteOrBlackTextColor = function getWhiteOrBlackTextColor(color, colors, override) {
  var black = colors.black || _palette.default.black;
  var white = colors.white || _palette.default.white;
  var inflectionPoints = primaryColors.reduce(function (acc, color) {
    acc[color] = _colorAliases.default["backgroundColor_" + (color === 'theme' ? 'brand' : color) + "Primary"].split('_')[1];
    return acc;
  }, {});
  return override && typeof override.inflection === 'number' ? override.inflection > inflectionPoints[color] ? black : white : white;
};

var primaryColorsByVariation = function primaryColorsByVariation(colors) {
  if (colors === void 0) {
    colors = {};
  }

  return primaryColors.reduce(function (acc, color) {
    var override = colors[color];
    acc["color_" + color + "Primary"] = getWhiteOrBlackTextColor(color, colors, override);
    return acc;
  }, {});
};

function createTheme(options) {
  var colors = options && options.colors;
  var grayRamp = colors && colors.gray ? (0, _createColorRamp.default)(getRamp(colors.gray, 'gray'), 'color_gray_') : (0, _createColorRamp.default)(_palette.default.gray, 'color_gray_');
  var themeRamp = colors && colors.theme ? (0, _createColorRamp.default)(getRamp(colors.theme, 'theme'), 'color_theme_') : (0, _createColorRamp.default)(_palette.default.brand, 'color_theme_');
  return _objectSpread({}, (0, _themeFromTokens.default)(_mineralUiTokens.default), nonTokenVariables(colors), colors ? colorOverrides(colors) : undefined, colors ? primaryColorsByVariation(colors) : undefined, grayRamp, themeRamp, {
    color_black: colors && colors.black || _palette.default.black,
    color_white: colors && colors.white || _palette.default.white
  }, options && options.overrides);
}